/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import clsx from 'clsx';
import React, { useState } from 'react';

import { Navigation } from '../../components/Navigation/Navigation';
import { CLIENT_NAVIGATION_DRAWER_WIDTH } from '../../constants/settings';
import { FooterLayout } from '../FooterLayout/FooterLayout';
import { HeaderLayout } from '../HeaderLayout/HeaderLayout';
import { createMainLayoutStyles } from './MainLayout.styles';

type MainLayoutProps = {
  children: React.ReactNode;
};

export function MainLayout(props: MainLayoutProps) {
  const { children } = props;
  const classes = createMainLayoutStyles({
    drawerWidth: CLIENT_NAVIGATION_DRAWER_WIDTH,
  });
  const [drawerOpen, setDrawerOpen] = useState<boolean>(true);

  return (
    <div className={classes.root}>
      <HeaderLayout
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        drawerWidth={CLIENT_NAVIGATION_DRAWER_WIDTH}
      />
      <Navigation drawerWidth={CLIENT_NAVIGATION_DRAWER_WIDTH} drawerOpen={drawerOpen} />
      <main
        className={clsx({
          [classes.content]: true,
          [classes.contentShift]: drawerOpen,
        })}
      >
        <div className={classes.drawerHeader} />
        <div className={classes.contentBox}>{children}</div>
        <FooterLayout />
      </main>
    </div>
  );
}
